import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { FormProcessorComponent } from './form-processor.component';
import { SurveyModule } from 'survey-angular-ui';
import { NoResultsMessageModule, SpinnerModule } from '@tangilla/tg-ng-common';
import { ComplexFormsModule } from './configurations/complex-forms/complex-forms.module';
import { WidgetsModule } from './widgets/widgets-module';
import { RecnIframeModule } from '@tangilla/tg-ng-payments';
import { ExitFormComponent } from './exit-form/exit-form.component';
import { Serializer } from 'survey-core';

initializeCustomProperties();
const routes: Routes = [
  {
    path: '', component: FormProcessorComponent
  }
];

@NgModule({
  declarations: [
    FormProcessorComponent,
    ExitFormComponent
  ],
  imports: [
    RouterModule.forChild(routes),
    CommonModule,
    SurveyModule,
    SpinnerModule,
    NoResultsMessageModule,
    ComplexFormsModule,
    WidgetsModule,
    RecnIframeModule,
  ]
})
export class FormProcessorModule {
}

function initializeCustomProperties() {
  Serializer.addProperty('questionbase', {
    name: 'includeInOutput',
    type: 'boolean',
    default: true
  });
  Serializer.addProperty('questionbase', {
    name: 'identifyingQuestion',
    type: 'boolean',
    default: false
  });
  Serializer.addProperty('questionbase', {
    name: 'reportLabel',
    type: 'string',
    default: null
  });
}
